import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Ticker } from "../components/site/Ticker";
import { SelectedWork } from "../components/site/SelectedWork";
import { WhyUs } from "../components/site/WhyUs";
import { Process } from "../components/site/Process";
import { About } from "../components/site/About";
import { Faq } from "../components/site/Faq";
import { FinalCta } from "../components/site/FinalCta";
import { Footer } from "../components/site/Footer";
import { VideoModal } from "../components/site/VideoModal";
import { ContactProvider } from "../context/ContactContext";

export default function Landing() {
  useLenis();
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
  }, []);

  return (
    <div className="grain relative min-h-screen" data-testid="landing-page">
      <ContactProvider>
        <Nav />
        <main>
          <Hero featured={projects[0]} onPlay={setActive} />
          <Ticker />
          <SelectedWork projects={projects} onPlay={setActive} />
          <WhyUs />
          <Process />
          <About />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
        <VideoModal project={active} onClose={() => setActive(null)} />
      </ContactProvider>
    </div>
  );
}
